import {Component, OnInit, AfterViewInit, ViewChild, ElementRef} from "@angular/core";
import {QuizService} from "../quiz.service";
import {QuestionService} from "../question.service";
import {AuthService} from "../auth.service";
import {Quiz} from "../quiz";
import {Question} from "../question";

declare var PDFDocument: any;
declare var QRCode: any;
declare var blobStream: any;

@Component({
  selector: "app-quizzes-table",
  templateUrl: "./quizzes-table.component.html",
  styleUrls: ["./quizzes-table.component.css"]
})
export class QuizzesTableComponent implements OnInit, AfterViewInit {

  public quizzes: Quiz[];
  public questions: Question[];
  public activeQuiz: Quiz = null;
  public activeQuestion: Question = null;
  public showSV = false;
  public pdfCreated = false;
  @ViewChild("pdfelement") pdfelement: ElementRef;

  constructor(private quizService: QuizService,
              private questionService: QuestionService,
              private authService: AuthService) {}

  ngOnInit() {
    this.quizService.quizzes$.subscribe(quizzes => this.quizzes = quizzes.sort((a, b) => {
      if (a.quizName_fi < b.quizName_fi) {
        return -1;
      } else if (a.quizName_fi > b.quizName_fi) {
        return 1;
      } else {
        return 0;
      }
    }));
  }

  ngAfterViewInit() {
    // console.log(this.pdfelement.nativeElement.value);
  }

  loadPDF() {
    const document: any = new PDFDocument({
      size: [595, 842],
      margins: {
        top: 40,
        bottom: 20,
        left: 40,
        right: 40
      }
    });
    const qrcode2 = new QRCode(null, {
      width: 400,
      height: 400
    });
    const stream = document.pipe(blobStream());

    for (const q of this.questions) {

      document.fontSize(20)
        .text("METSÄVISA 2017",
          {
            align: "center"
          }
        )
        .fontSize(20)
        .text("" + q.ordinal,
          {
            align: "center"
          }
        )
        .moveDown()
        .fontSize(20)
        .text(q.questionLabel_fi,
          {
            align: "center"
          }
        )
        .text( q.questionLabel_sv,
          {
            align: "center"
          }
        );

      const centerX = (595 - 400) / 2;
      const imgUri = qrcode2.getBase64ImageSrc(q.code);
      document.image(imgUri, centerX);
      document.moveDown()
        .fontSize(120)
        .text(q.code, {
          align: "center"
        });
      if (this.questions.indexOf(q) != this.questions.length - 1) {
        document.addPage();
      }
    }

    document.end();
    stream.on("finish", () => {
      const blob = stream.toBlob("application/pdf");

      // let url = stream.toBlobURL('application/pdf');
      console.log("PDF is", blob);

      const saveData = (blob: Blob, fileName: string) => {
        console.log("this pdf element", this.pdfelement);
        const url = URL.createObjectURL(blob);
        this.pdfelement.nativeElement.href = url;
        this.pdfelement.nativeElement.download = fileName;
        this.pdfelement.nativeElement.style = "visibility: visible";
        this.pdfCreated = true;

      };
      saveData(blob, "code.pdf");
    });
  }


  protected getAnswerString(question: Question): string {
    let result = "";

    if (question.answerArray.length === 0) {
      result = "Ei vastauksia";
    } else {
      for (const index in question.answerArray) {
        result += "" + (+index + 1 ) + ": " + question.answerArray[index].answerLabel_fi + " (" + question.answerArray[index].score + " pistettä)<br />";
      }
    }
    return result;
  }

  remove(quiz: Quiz): void {
    const r: boolean = confirm("Haluatko varmasti poistaa visan " + quiz.quizName_fi + "?" + " Kaikki visassa olevat kysymykset poistetaan myös.");

    if (r === true) {
      for (let i = 0; i < quiz.questionArray.length; i++) {
        this.questionService.removeQuestion(quiz.questionArray[i].toString()).subscribe(res => {
          if (res) {
            // console.log
          } else {
            console.error("Jokin meni vikaan kysymystä " + i + " poistettaessa.");
          }
        });
      }

      this.quizService.removeQuiz(quiz._id).subscribe(res => {
        if (res) {
          alert("Visan poisto onnistui!");
        } else {
          alert("Visan poisto epäonnistui!");
        }
      });
    }
  }

  addNewQuiz(): void {
    this.activeQuiz = new Quiz();
    this.activeQuiz.questionArray = [];
    this.setRandomCode(this.activeQuiz);
    this.activeQuiz.ordinal = this.quizzes.length + 1;
    this.activeQuiz.useCode = true;
    this.save(this.activeQuiz);
  }

  randomString(length: number, chars: string): string {
    let result = "";

    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }

    return result;
  }

  setRandomCode(quiz: Quiz) {
    quiz.joinToken = this.randomString(5, "23456789ABCDEFGHJKLMNPQRSTUVWXYZ"); // abcdefghijkmnopqrstuvwxyz
  }
  setRandomCodeQuestion(question: Question) {
    question.code = this.randomString(this.authService.currentAdmin$.value.settings.codeLenght, "23456789ABCDEFGHJKLMNPQRSTUVWXYZ"); //abcdefghijkmnopqrstuvwxyz
  }

  getMaxPoints(question: Question): string {
    if (question.answerArray.length === 0) {
      return "--";
    }
    let maxScore = question.answerArray[0].score;
    for (const answer of question.answerArray) {
      maxScore = Math.max(maxScore, answer.score);
    }
    return "" + maxScore;
  }

  removeQuestion(quiz: Quiz, question: number): void {
    quiz.questionArray.splice(question, 1);
  }

  addNewQuestion(quiz: Quiz): void {
    const q = new Question();
    q.answerAmount = 1;
    q.answerArray = [];
    this.setRandomCodeQuestion(q);
    q.ordinal = this.questions.length + 1;
    q.timeLimitSeconds = 30;
    quiz.questionArray.push(q._id);
  }

  save(quiz: Quiz) {
    if (quiz._id) {
      this.quizService.updateQuiz(quiz)
        .subscribe(
          res => {
            if (res) {
              this.activeQuiz = null;
              alert("Visan tallennus onnistui!");
            } else {
              alert("Visan tallennus epäonnistui!");
            }
          },
          err => {
            alert("Visan talennus epäonnistui pahasti!");
          }
        );
    } else {
      this.quizService.addQuiz(quiz)
        .subscribe(
          res => {
            if (res) {
              this.activeQuiz = null;
              alert("Uuden visan luonti onnistui!");
            }
            else {
              alert("Uuden visan luonti epäonnistui!");
            }
          },
          err => {
            alert("Uuden visan luonti pahasti!");
            console.error(err);
          });
    }
  }

  get diagnostic(): string {
    return JSON.stringify(this.activeQuiz);
  }

  edit(quiz: Quiz) {
    this.activeQuiz = quiz;
    window.location.href = "/admin/questions/" + this.activeQuiz._id;
  }

  cancel() {
    this.quizService.loadQuizList();
    this.activeQuiz = null;
  }

  showSwedish() {
    this.showSV = !this.showSV;
  }

  changeAnswerLimitType(question: Question) {
    if (question.answerAmount === 0) {
      question.answerAmount = -1;
    } else {
      question.answerAmount = -question.answerAmount;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/quizzes-table/quizzes-table.component.ts